<template>
    <div class="totallingTargetListContainer" :style="cssGridRows">
        <div class="totallingTargetListHeader">
            <input class="searchInputText" type="text" placeholder="グループ名 / 商品名 / 商品コード" v-model="searchKeyword" />
            <slot name="header-action"></slot>
        </div>
        <div v-if="showSelected" class="selectedTotallingTarget">選択中商品 : {{ this.selectedTotallingTargetName }}</div>
        <div class="totallingTargetList">
            <transition-group tag="ul" :style="cssValueListColumn">
                <li v-for="totallingTarget in dispTotattingTargets" :key="totallingTarget.id"
                    class="totallingTargetItem" :class="{ 'selected': value == totallingTarget.id }"
                    @click="selectTotallingTarget(totallingTarget)" @mouseover="showTooltip(totallingTarget)"
                    @mouseleave="hideTooltip">
                    <div>{{ totallingTarget.name }}
                        <span v-if="totallingTarget.products.length > 1">（{{ totallingTarget.products.length
                            }}商品）</span>
                    </div>
                    <!-- ツールチップの表示 -->
                    <div v-if="tooltip.visible && tooltip.id === totallingTarget.id" class="tooltip"
                        :style="tooltipStyle" v-html="tooltip.content"></div>
                </li>
            </transition-group>
            <transition>
                <div v-if="dispTotattingTargets.length == 0" class="noData">該当する商品がありません。</div>
            </transition>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    data() {
        return {
            searchKeyword: '',
            filterKeyword: '',
            totallingTargets: [],
            tooltip: {
                visible: false,
                id: null,
                content: '',
            },
            mousePosition: {
                top: 0,
                left: 0,
            },
        };
    },
    props: {
        value: Number,
        customFilter: Function,
        returnObject: {
            type: Boolean,
            default: false,
        },
        showSelected: {
            type: Boolean,
            default: false,
        },
        listColumn: {
            type: Number,
            default: 1,
        },
        addFetchParameters: {
            type: Object,
            default: null,
        },
        productId: Number,
    },
    mounted: async function () {
        if (this.productId != 0) {
            this.searchKeyword = this.productId;
            this.filterKeyword = this.productId.toString();
            this.productId = 0;
        }
        const res = await this.axios.get('/api/totallingTargets');
        const totallingTargets = res.data;
        this.totallingTargets = totallingTargets.map(totallingTarget => {
            const productKeywords = totallingTarget.products.map(
                product => `${product.id} ${product.name}`.toKeyword()
            ).join(' ');

            totallingTarget._keyword = `${totallingTarget.name} ${productKeywords}`.toKeyword();
            return totallingTarget;
        });
        // マウスムーブイベントを監視
        document.addEventListener('mousemove', this.updateMousePosition);
    },
    beforeDestroy() {
        // コンポーネントが破棄される前にマウスムーブイベントのリスナーを解除
        document.removeEventListener('mousemove', this.updateMousePosition);
    },
    methods: {
        selectTotallingTarget(product) {
            const { _keyword, ...returnObject } = product;
            _keyword; // for eslint
            this.$emit('input', this.returnObject ? returnObject : product.id);
        },
        showTooltip(totallingTarget) {
            this.tooltip.visible = true;
            this.tooltip.id = totallingTarget.id;

            this.tooltip.content = ''; // Initialize as an empty string before concatenation

            totallingTarget.products.forEach((element) => {
                this.tooltip.content += `${element.name}<br>`;
            });

            this.tooltip.content = this.tooltip.content.replace(/<br>$/, '');
        },
        hideTooltip() {
            this.tooltip.visible = false;
            this.tooltip.id = null;
            this.tooltip.content = '';
        },
        updateMousePosition(event) {
            // マウスの位置を更新
            this.mousePosition.top = event.clientY;
            this.mousePosition.left = event.clientX;
        },
    },
    watch: {
        searchKeyword: _.debounce(function (newVal) {
            this.filterKeyword = newVal.toKeyword();
        }, 500),
    },
    computed: {
        selectedTotallingTargetName: function () {
            if (this.value) {
                return this.totallingTargets.find(totattingTarget => totattingTarget.id == this.value).products[0].name;
            } else {
                return '';
            }
        },
        dispTotattingTargets: function () {
            let totattingTargets = this.totallingTargets;

            if (this.customFilter) {
                totattingTargets = _.filter(totattingTargets, this.customFilter);
            }

            if (this.filterKeyword) {
                const filterKeywordLower = this.filterKeyword.toLowerCase();
                totattingTargets = _.filter(totattingTargets, (totattingTarget) => {
                    return totattingTarget._keyword.toLowerCase().indexOf(filterKeywordLower) > -1;
                });
            }

            return totattingTargets;
        },
        cssGridRows: function () {
            if (this.showSelected) {
                return `grid-template-rows: 44px 30px 1fr`;
            } else {
                return `grid-template-rows: 44px 1fr`;
            }
        },
        cssValueListColumn: function () {
            return `--column: ${this.listColumn}`;
        },
        tooltipStyle() {
            return {
                top: `${this.mousePosition.top - 100}px`,  // マウスの位置の少し下
                left: `${this.mousePosition.left - 100}px`,  // マウスの位置の少し右
                position: 'absolute',
                transform: 'translate(0, 0)', // 位置調整のためのトランスフォーム
            };
        },
    },
};
</script>

<style scoped lang="sass">
.totallingTargetListContainer
    padding: 0
    height: 100%
    width: 100%
    display: inline-grid
    grid-template-columns: 1fr
    grid-row-gap: 10px
    .totallingTargetListHeader
        overflow: hidden
        padding: 0
        .searchInputText
            display: block
            float: left
            padding: 10px
            width: 30%
            min-width: 250px
            margin: 2px
            &:focus
                outline: 2px solid $mainColor
    .selectedTotallingTarget
        border-bottom: 2px solid #E6E6E6
        color: $grayColor
        font-size: 1.5rem
        height: 30px
        margin: 0
        padding: 7px
        width: 30%
        min-width: 250px
    .totallingTargetList
        color: $grayColor
        font-size: 1.5rem
        overflow-y: scroll
        margin: 0
        padding: 0
        ul
            display: flex
            flex-wrap: wrap
            --column: 4
            li
                overflow: hidden
                display: inline-flex
                align-items: center
                margin: 2px
                padding: 7px 2px
                width: calc(100% / var(--column) - 4px)
                height: 40px
                background: #f5f5f5
                white-space: nowrap
                cursor: pointer
                &:hover
                    background: $grayColor
                    color: $whiteColor
                    transition: 0.2s ease-out
        .noData
            height: 50%
            display: grid
            place-items: center
        .selected
            background: $grayColor
            color: $whiteColor
        .tooltip
            position: absolute
            transform: translateX(-50%)
            background-color: $whiteColor
            color: $grayColor
            padding: 5px 10px
            border-radius: 4px
            z-index: 100
            font-size: 12px
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2)
            white-space: normal
            word-wrap: break-word
            max-width: 200px
            overflow-wrap: break-word
@include sp()
    .totallingTargetListContainer
        margin-top: 30px
        .totallingTargetItem
            padding: 0 10px !important
            font-size: 12px
</style>
